import { Menu, PanelLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { useSidebarMode, type SidebarMode } from './appSidebarProvider';
import { useSidebar } from '../ui/sidebar';

const LABELS: Record<SidebarMode, string> = {
  collapsed: 'Collapsed',
  expanded: 'Expanded',
  hover: 'Expand on hover',
};

export const SidebarControl = () => {
  const { mode, setMode } = useSidebarMode();
  const { isMobile, toggleSidebar } = useSidebar();

  // The three modes describe a rail that only exists on desktop; on mobile the
  // sidebar is a Sheet, and toggleSidebar is the only thing that opens it.
  if (isMobile) {
    return (
      <Button
        variant="ghost"
        size="icon"
        className="size-7"
        onClick={toggleSidebar}
      >
        <Menu />
        <span className="sr-only">Open menu</span>
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="size-7">
          <PanelLeft />
          <span className="sr-only">Sidebar mode</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuRadioGroup
          value={mode}
          onValueChange={(value) => {
            setMode(value as SidebarMode);
          }}
        >
          {Object.entries(LABELS).map(([value, label]) => (
            <DropdownMenuRadioItem key={value} value={value}>
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
